import React from 'react'

//componentes
import PerfilComponent from '../components/perfil/PerfilComponent';
import ProjectsComponent from './ProjectsComponent';
import SkillsComponent from './SkillsComponent';
import ServicesComponent from './ServicesComponent';
import ContactComponent from '../components/contact/ContactComponent';
import NavbarComponent from './NavbarComponent';
import Footer from './Footer';
const MainComponent = () => {      
  return (
    <>
      <PerfilComponent />
      <ProjectsComponent />
      <SkillsComponent />
      <div className="container section job-contact__grid grid">
        <ServicesComponent />
        <ContactComponent />
      </div>
      <NavbarComponent />
      <Footer />
   </>

  )
 }

 export default MainComponent;

